exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1Q3scbUvAgP_hRG7PGakn{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}@media screen and (-ms-high-contrast:active){._3QEIhGWDMMp1pnzADGXRY_,._1dI05iBqLNzdMiJK1FVA3F{-ms-high-contrast-adjust:none;color:var(--neutralSecondary)}}._1dI05iBqLNzdMiJK1FVA3F._2ku0nP_adSQL2THBkixc3i,._1dI05iBqLNzdMiJK1FVA3F._17rHATEhMrMW5NmE1nKUmX{font-weight:400;font-size:11px}._1dI05iBqLNzdMiJK1FVA3F._1MTQd-7t9b-A4dhjUuoYbO{font-size:12px}@media screen and (-ms-high-contrast:active){._12YqE07cIgWKRg9SsAMfXH{-ms-high-contrast-adjust:none;color:var(--neutralSecondary)}}", ""]);
// Exports
exports.locals = {
	"textOverFlow": "_1Q3scbUvAgP_hRG7PGakn",
	"firstLineCommonStyle": "_3QEIhGWDMMp1pnzADGXRY_",
	"firstLineCommonStyleNext": "_1dI05iBqLNzdMiJK1FVA3F",
	"compact": "_2ku0nP_adSQL2THBkixc3i",
	"medium": "_17rHATEhMrMW5NmE1nKUmX",
	"full": "_1MTQd-7t9b-A4dhjUuoYbO",
	"secondLineCommonStyle": "_12YqE07cIgWKRg9SsAMfXH"
};